var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiguregymnastics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 25.4461 21.457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 21.457,
    opacity: 0,
    width: 25.4461,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6058 5.12109C14.0121 5.12109 15.1605 3.97266 15.1605 2.54297C15.1605 1.13672 14.0121 0 12.6058 0C11.1762 0 10.0394 1.13672 10.0394 2.54297C10.0394 3.97266 11.1762 5.12109 12.6058 5.12109ZM1.70741 15.9609L7.59022 16.4531C8.64491 16.5469 8.86757 16.6172 9.87538 16.8984L17.0473 18.9141L23.4926 21.2695C24.0551 21.4688 24.8168 21.2695 25.0394 20.5547C25.2269 19.9336 24.9457 19.2539 24.3246 19.0312L17.891 16.6875C17.7855 16.6523 17.5746 16.5703 17.4926 16.5352L12.4887 14.7305C13.1566 13.4531 14.059 11.4023 14.2933 9.17578C14.3168 8.91797 14.4808 8.78906 14.7152 8.78906L23.3168 8.78906C23.9848 8.78906 24.5004 8.25 24.5004 7.59375C24.5004 6.92578 23.9848 6.39844 23.3168 6.39844L13.8832 6.39844C12.3012 6.39844 12.1605 6.38672 10.4379 5.91797L1.51991 3.44531C0.87538 3.26953 0.230849 3.64453 0.0433487 4.27734C-0.132433 4.92188 0.242567 5.57812 0.87538 5.75391L9.19569 8.05078C9.40663 8.10938 9.54725 8.27344 9.52382 8.51953C9.25429 10.6172 8.23475 12.6445 7.69569 13.5703L2.99647 13.5703L2.99647 8.78906C2.99647 8.13281 2.43397 7.59375 1.78944 7.59375C1.13319 7.59375 0.59413 8.13281 0.59413 8.78906L0.59413 14.7539C0.59413 15.457 0.910536 15.8789 1.70741 15.9609Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiguregymnastics);
export default __webpack_public_path__ + "static/media/figure.gymnastics.0bf1f1600f6ff483f20d86cd92c75335.svg";
export { ForwardRef as ReactComponent };